import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['answer', 'icon'];

  connect() {
    this.expanded = false;
    this.iconBaseClass = this.iconTarget.className;

    requestAnimationFrame(() => {
      this.height = this.answerTarget.getBoundingClientRect().height;
      this.answerTarget.style.height = 0;
    });
  }

  expand() {
    if (this.expanded) {
      this.answerTarget.style.height = '0px';
      this.iconTarget.className = this.iconBaseClass;
    } else {
      this.answerTarget.style.height = `${this.height}px`;
      this.iconTarget.className = `${this.iconBaseClass} bg-primary-500 text-primary-900 rotate-180`;
    }

    this.expanded = !this.expanded;
  }
}
